import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReflectionState } from '../reducers/reflection.reducer';
import { REFLECTION_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ReflectionState>(REFLECTION_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: ReflectionState) => state.entries[id]?.loaded ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state: ReflectionState) => state.entries[id]?.loading ?? false);
export const selectReflection = (id: string) => createSelector(selectState, (state: ReflectionState) => state.entries[id]?.reflection ?? null);
export const selectSaving = createSelector(selectState, (state: ReflectionState) => state.saving);
export const selectSaved = createSelector(selectState, (state: ReflectionState) => state.saved);
export const selectError = (id: string) => createSelector(selectState, (state: ReflectionState) => state.entries[id]?.error ?? null);
export const selectCreatedId = createSelector(selectState, (state: ReflectionState) => state.createdId);
